import { color, media, radius, spacing, typography } from '@gyym/ui'
import styled from 'styled-components'

export const CategoryButtonInner = styled.div`
  ${typography('body1')};
  transition: none;
  color: ${color('gray.01')};
  width: 100%;
  background: none;
  display: flex;
  gap: ${spacing(2)};
  cursor: pointer;
  text-align: left;
  justify-content: flex-start;
  align-items: flex-start;
  padding: ${spacing(4, 0)};
  border: none;
  border-top: 1px solid ${color('gray.05')};
  border-radius: 0;

  ${media.pc} {
    padding: ${spacing(6)};
    text-align: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid ${color('gray.03')};
    border-radius: ${radius('md')};
  }
`

export const Category = styled.li`
  width: 100%;

  &:last-child {
    border-bottom: 1px solid ${color('gray.05')};
  }

  ${media.pc} {
    &:last-child {
      border-bottom: none;
    }
  }
`

export const History = styled.li`
  width: 100%;

  &:last-child {
    border-bottom: 1px solid ${color('gray.05')};
  }

  & > button,
  & > a {
    ${typography('caption1')};
    transition: none;
    color: ${color('gray.01')};
    width: 100%;
    background: none;
    display: flex;
    gap: ${spacing(2)};
    cursor: pointer;
    text-align: left;
    justify-content: flex-start;
    align-items: flex-start;
    padding: ${spacing(4, 0)};
    border: none;
    border-top: 1px solid ${color('gray.05')};
    border-radius: 0;
  }
`
